export const HandleStepChange = (store, currentStep) => {
  store.dispatch({
    type: "installer/updateCurrentStep",
    payload: {
      newStep: currentStep,
    },
  });
};
